export default {
  circleChartTitle1: {
    id: 'merchant_onboarding_home_circle_chart_title_1',
    defaultMessage: 'Roll up your sleeves.',
  },
  circleChartTitle2: {
    id: 'merchant_onboarding_home_circle_chart_title_2',
    defaultMessage: 'The first step is the hardest.',
  },
  circleChartTitle3: {
    id: 'merchant_onboarding_home_circle_chart_title_3',
    defaultMessage: 'You’re on a roll.',
  },
  circleChartTitle4: {
    id: 'merchant_onboarding_home_circle_chart_title_4',
    defaultMessage: 'Don’t stop onboardin’. Hold on to that feelin’. 🎵',
  },
  circleChartTitle5: {
    id: 'merchant_onboarding_home_circle_chart_title_5',
    defaultMessage: 'You’re officially over the hump.',
  },
  circleChartTitle6: {
    id: 'merchant_onboarding_home_circle_chart_title_6',
    defaultMessage: 'Just add coffee.',
  },
  circleChartTitle7: {
    id: 'merchant_onboarding_home_circle_chart_title_7',
    defaultMessage: 'You: “Are we there yet?”',
  },
  circleChartTitle8: {
    id: 'merchant_onboarding_home_circle_chart_title_8',
    defaultMessage: 'You did it. High five!”',
  },
  circleChartDescription1: {
    id: 'merchant_onboarding_home_circle_chart_description_1',
    defaultMessage:
      'The faster you onboard, the faster you can get your renewed items in front of customers.',
  },
  circleChartDescription2: {
    id: 'merchant_onboarding_home_circle_chart_description_2',
    defaultMessage:
      'And you did it with ease. What else can you check off the list?',
  },
  circleChartDescription3: {
    id: 'merchant_onboarding_home_circle_chart_description_3',
    defaultMessage:
      'We would have picked you as our study buddy back in school.',
  },
  circleChartDescription4: {
    id: 'merchant_onboarding_home_circle_chart_description_4',
    defaultMessage:
      'No worries, there’s no chance of us quitting our day jobs. But seriously, keep going. You’re almost halfway there!',
  },
  circleChartDescription5: {
    id: 'merchant_onboarding_home_circle_chart_description_5',
    defaultMessage:
      'In the onboarding process, that is. We can’t help you with the day of the week.',
  },
  circleChartDescription6: {
    id: 'merchant_onboarding_home_circle_chart_description_6',
    defaultMessage:
      'You’re so close. Pour another cup to get over the onboarding finish line.',
  },
  circleChartDescription7: {
    id: 'merchant_onboarding_home_circle_chart_description_7',
    defaultMessage:
      'Almost. Keep it up, and you’ll be a Back Market seller in no time.',
  },
  circleChartDescription8: {
    id: 'merchant_onboarding_home_circle_chart_description_8',
    defaultMessage:
      'Now sit back and relax. Your Back Market point of contact will review your documents and activate your account within 24 hours.',
  },
}
